import RequestAbstract from "../abstract";

export default class Transactions extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/transactions";
    }
}
